<template>
  <div class="single-date-picker__calendar-month-header">
    <div class="single-date-picker__arrow left" @click="toggleMonth(-1)">
      <i class="pp-icon pp-icon-arrow"></i>
    </div>
    <div class="single-date-picker__year">
      {{ fullMonth }} {{ year }}
    </div>
    <div class="single-date-picker__arrow right" @click="toggleMonth(1)">
      <i class="pp-icon pp-icon-arrow"></i>
    </div>

    <div class="calendar-close pp-icon pp-icon-close" @click="closeCalendar()"></div>
  </div>
</template>

<script>

const MONTHS = {'ru': [
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь'
], 'en': [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december'
]};
export default {
  props: {
    year: {
      type: Number,
      default: () => 1970
    },
    month: {
      type: Number,
      default: () => 0
    },
    lang: {
      type: String,
      default: () => 'ru'
    }
  },
  computed: {
    fullMonth() {
      return MONTHS[this.lang][this.month];
    }
  },
  methods: {
    toggleMonth(direction) {
      this.$emit('toggleMonth', direction)
    },
    closeCalendar() {
      this.$store.commit('basket/setOpenCalendar', false)
    }
  }
};
</script>

<style lang="scss" scoped>
.single-date-picker {
  &__arrow{
    &.left{
      transform: rotate(-180deg);
    }
  }
}
.single-date-picker__calendar-month-header {
  padding: 15px;
  background-color: #fd813d;
  display: flex;
  justify-content: space-between;
  border-radius: 0.25rem;
  align-items: center;
  color: #fff;

  .single-date-picker__year {
    width: 60%;
    font-weight: 900;
    font-size: 20px;
    text-transform: capitalize;
  }
  .single-date-picker__arrow {
    cursor: pointer;
  }
}
</style>